import { Box } from '@chakra-ui/react';
import React from 'react';

export interface TableScrollWrapperProps {
  children: React.ReactNode;
  /** Minimum width before horizontal scroll activates (default: '600px') */
  minWidth?: string;
}

/**
 * Horizontal scroll wrapper for tables.
 *
 * Enables horizontal scrolling when the table content is narrower
 * than the configured minWidth.
 *
 * @useFor wrapping a wide `<DataTable>` (many columns) so it scrolls
 *   horizontally on narrow viewports instead of overflowing the
 *   page chrome.
 *
 *   Pair with `<TableContainer>` for vertical scroll + this for
 *   horizontal. Default `minWidth='600px'` is a reasonable starting
 *   threshold; bump it when the table has many columns.
 *
 *   For non-table horizontal scroll (carousels, sticky-header lists)
 *   use a different primitive — this is table-specific.
 */
export function TableScrollWrapper({
  children,
  minWidth = '600px',
}: TableScrollWrapperProps) {
  return (
    <Box overflowX="auto" maxWidth="100%">
      <Box minWidth={minWidth}>{children}</Box>
    </Box>
  );
}
